module.exports = __webpack_public_path__ + "static/media/45.5ef1b673.png";